import React from "react";

export interface IOption
{
    label: string;
    value: any;
}

interface SelectProps {
    label: string;
    name: string;
    value?: any;
    options: IOption[];
    className?: any;
    onChange: (value: any) => void
}
export function Select(props: SelectProps) {
    const { name, value, label, options, className } = props;
    const onChange = (ev: any) => {
        var value = ev.target.value;
        if (value !== props.value) {
            props.onChange(value);
        }
    };
    return (
        <label>
            <span className="field">{props.label}</span>
            <select className={className} name={name} value={value} placeholder={label} onChange={onChange}>
                {options.map((o, i) => <option key={i} value={o.value}>{o.label}</option>)}
            </select>
        </label>
    );
}
